import {
    Accordion,
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
    Badge,
    Box,
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    Skeleton,
    Tooltip
} from "@chakra-ui/react"
import {useEffect, useState} from "react";
import React from 'react';
import {ClienteF} from "../util/ClienteFormarte";
import {FaRegCalendarTimes} from "react-icons/fa";

export default function ModalAtendimentos(props) {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (props.able) {
            setTimeout(() => {
                setIsLoading(true);
            }, 1500);
        }
    }, [props.able]);

    const handleBack = () => {
        props.close(); // Chama o onClose passado pelas props
    };

    return (
        <Modal isOpen={props.able} onClose={handleBack} closeOnOverlayClick={false}>
            <ModalContent>
                <ModalHeader textAlign={'center'}>Seus agendamentos</ModalHeader>
                <ModalCloseButton/>
                <ModalBody>
                    <Skeleton isLoaded={isLoading}>
                        <Accordion defaultIndex={[0]} allowToggle h={300} overflowY={'scroll'}>
                            {(props.atendimentos.length !== 0) ? props.atendimentos.map((e, index) =>
                                <AccordionItem key={index}>
                                    <h2>
                                        <AccordionButton justifyContent={'space-between'}>
                                            <Badge borderRadius='full' px='2'
                                                   colorScheme={ClienteF.colorBadge(e.idStatus)}>
                                                {ClienteF.statusString(e.idStatus)}
                                            </Badge>
                                            <Box>
                                                {ClienteF.formataNome(e.medico.nome)}
                                            </Box>
                                            <Box
                                                color='gray.500'
                                                fontWeight='semibold'
                                                letterSpacing='wide'
                                                fontSize='xs'
                                                ml='2'
                                            >
                                                {ClienteF.formataData(e.data)}
                                            </Box>
                                            <AccordionIcon/>
                                        </AccordionButton>
                                    </h2>
                                    <AccordionPanel pb={4} display={'flex'}>
                                        <Box>
                                            {<b>Procedimento:</b>} {e.procedimento.procedimento}{<br/>}
                                            {<b>Data do agendamento:</b>} {ClienteF.formataData(e.dataAgendamento)}{
                                            <br/>}
                                            {<b>Contato cadastrado:</b>} {e.telefone}
                                        </Box>
                                        {e.idStatus == 1 ?
                                            < Tooltip label="Cancelar Agendamento">
                                                <Button colorScheme={'red'}
                                                onClick={()=>props.cancela(e.idAgenda)}>
                                                    <FaRegCalendarTimes/>
                                                </Button>
                                            </Tooltip> : null
                                        }
                                    </AccordionPanel>
                                </AccordionItem>
                            ) : <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>Não houve
                                nenhum
                                agendamento</Box>}
                        </Accordion>
                    </Skeleton>
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme={'blue'} mr={3} onClick={handleBack}>
                        Fechar
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}
